import React, { useContext } from 'react'

import { LanguageContext } from '../../context/LanguageContext'
import type { CalculationType } from '../../types/types'
import { viewLocalizedText } from '../../utils/viewLocalizedText'
import { Panel } from '../Panel/Panel'

interface Props {
  calculation?: CalculationType
}

/**
 * What this app shows in place of a licensed instrument.
 *
 * For an instrument Awell holds no licence to republish, the API withholds the
 * item text and the documentation and refuses to run it from here. So there is
 * no form to render and no documentation to show: what remains is the
 * description Awell wrote itself, which already names the rights holder and
 * where to go for a licence.
 */
export const LicensedInstrument: React.FC<Props> = ({
  calculation
}): React.ReactElement => {
  const { userLanguage } = useContext(LanguageContext)

  const description = viewLocalizedText({
    fallback: '',
    label: calculation?.public_description,
    language: userLanguage
  })

  return (
    <Panel>
      <div className='px-6 sm:px-8 pb-8' data-cy='licensed-instrument'>
        <p className='text-gray-700'>
          {description === ''
            ? 'This instrument is subject to third-party copyright.'
            : description}
        </p>
      </div>
    </Panel>
  )
}
